<template>
  <div>
    <PCNavbar selectIndex="2-1"/>
    <MobileNavBar :currentActive="1" />
    <ProductionBrain />
  </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import ProductionBrain from '@/components/production/ProductionBrain.vue'
export default {
  components: {
    PCNavbar,
    MobileNavBar,ProductionBrain

  },
}
</script>

<style>
</style>